import { render, staticRenderFns } from "./departmentrentercrud.vue?vue&type=template&id=ff44b220&"
import script from "./departmentrentercrud.vue?vue&type=script&lang=js&"
export * from "./departmentrentercrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports